/**
 * 録音の共通設定。AssignmentView / HonbanMode / RenshyuMode の3か所で使う。
 *
 * ⚠️ 3か所にコピーしないこと。ビットレートがズレると、容量の見積もりと
 *    実際の使用量が食い違う。
 */

/**
 * 録音のビットレート（bps）。
 *
 * ⚠️ 指定しないとブラウザ既定の約130kbpsになる。音声には過剰で、90秒の録音が
 *    1.46MBになる。配布課題では「35人 × 20登校日」でSupabaseの無料枠1GBが
 *    先生1人で埋まり、base64にすると4分程度でVercelのボディ上限4.5MBに当たる。
 *
 * 32kbpsでも Whisper の文字起こしは完全に一致し、聴感の差もほぼ無いことを
 * 実測で確認済み（2026-08-15・101.2KB → 23.1KB）。
 *
 * ⚠️ 上げるときは「1件あたりのサイズ × 35人 × 20登校日」を計算してから。
 */
export const AUDIO_BITRATE = 32000;

/** ブラウザが扱えるMIMEタイプ（iOSはwebm非対応でmp4になる） */
export function getRecordingMimeType() {
  if (MediaRecorder.isTypeSupported('audio/webm')) return 'audio/webm';
  if (MediaRecorder.isTypeSupported('audio/mp4'))  return 'audio/mp4';
  return '';
}

/**
 * 録音用の MediaRecorder を作る。
 * MIMEタイプが判定できない環境ではビットレートだけ指定して既定の形式に任せる。
 */
export function createRecorder(stream) {
  const mimeType = getRecordingMimeType();
  return new MediaRecorder(
    stream,
    mimeType
      ? { mimeType, audioBitsPerSecond: AUDIO_BITRATE }
      : { audioBitsPerSecond: AUDIO_BITRATE }
  );
}
